export default "__VITE_ASSET__DCzW8Jpy__"